import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../Constants";
//export const baseUrl = "http://localhost:6464";

export const AdminSlice = createSlice({
  name: "admin",
  initialState: {
    sessions: [],
    isLoading: false,
    error: null,
    success: false,
  },
  reducers: {
    setSessions: (state, { payload }) => {
      state.sessions = payload;
      state.error = null;
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setSuccess: (state, { payload }) => {
      state.success = payload;
    },
  },
});

export const { setSessions, setLoading, setError, setSuccess } =
  AdminSlice.actions;
export default AdminSlice.reducer;

export const fetchSessions = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const res = await axios.get(`${baseUrl}/sessions`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    });
    const sessionsArray = Array.isArray(res.data)
      ? res.data
      : res.data?.data || [];
    dispatch(setSessions(sessionsArray));
  } catch (err) {
    dispatch(setError("Failed to fetch sessions"));
    console.error(err);
  } finally {
    dispatch(setLoading(false));
  }
};

export const uploadFile = (formData) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const res = await axios.post(`${baseUrl}/upload`, formData, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
      },
    });
    const sessionsArray = Array.isArray(res.data)
      ? res.data
      : res.data.insertedData || res.data.data || [];
    dispatch(setSessions(sessionsArray));
    dispatch(setSuccess(true));
    await dispatch(fetchSessions());
  } catch (err) {
    dispatch(setError("Upload failed"));
    console.error(err);
  } finally {
    dispatch(setLoading(false));
  }
};

export const downloadFile =
  (filters = {}) =>
  async (dispatch) => {
    try {
      const params = {};

      if (filters.capability) params.capability = filters.capability;
      if (filters.category) params.category = filters.category;
      if (filters.modeDelivery) params.modeDelivery = filters.modeDelivery;
      if (filters.targetAudience)
        params.targetAudience = filters.targetAudience;
      if (filters.searchTerm) params.search = filters.searchTerm;
      if (filters.startDate) params.startDate = filters.startDate.toISOString();
      if (filters.endDate) params.endDate = filters.endDate.toISOString();
      if (filters.country) {
        params.country = filters.country;
      }

      const response = await axios.get(`${baseUrl}/download`, {
        params,
        responseType: "blob",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "LKM_Calendar_Data.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();

      dispatch(setSuccess(true));
    } catch (err) {
      dispatch(setError("Download failed"));
      console.error(err);
    }
  };

export const deleteSession = (sessionId) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    await axios.delete(`${baseUrl}/sessions/${sessionId}`, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    await dispatch(fetchSessions());
    dispatch(setSuccess(true));
  } catch (err) {
    dispatch(setError("Failed to delete session"));
    console.error(err);
  } finally {
    dispatch(setLoading(false));
  }
};

export const updateSession = (sessionId, updatedData) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    await axios.put(`${baseUrl}/sessions/${sessionId}`, updatedData, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    });
    await dispatch(fetchSessions());
    dispatch(setSuccess(true));
  } catch (err) {
    dispatch(setError("Failed to update session"));
    console.error(err);
  } finally {
    dispatch(setLoading(false));
  }
};
